import { NgModule }                       from '@angular/core';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { CommonModule }                   from '@angular/common';
import { DomSanitizer }                   from '@angular/platform-browser';

import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { brandIcons, regularIcons, solidIcons } from './icons.config';
import { CUSTOM_ICONS }                         from './custom-icons';

import { IconComponent } from '@shared/icons/icon/red-icon.component';


@NgModule({
  declarations: [
    IconComponent,
  ],
  imports:      [
    CommonModule,
    MatIconModule,
    FontAwesomeModule
  ],
  exports:      [
    FontAwesomeModule,
    IconComponent,
  ]
})
export class IconsModule {
  constructor(
    library: FaIconLibrary,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer
  ) {
    library.addIcons(...solidIcons);
    library.addIcons(...regularIcons);
    library.addIcons(...brandIcons);

    this.registerCustomSvgIcons();
  }

  private registerCustomSvgIcons(): void {
    CUSTOM_ICONS.forEach(icon => {
      this.matIconRegistry.addSvgIcon(
        icon.name,
        this.domSanitizer.bypassSecurityTrustResourceUrl(icon.path)
      );
    });
  }
}
